import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './StoryGame.css'; // Optional: Add your own CSS for styling

const StoryGame = () => {

};

export default StoryGame;
